// extracted by extract-css-chunks-webpack-plugin
module.exports = {"map":"map____53E1","catalogs-info-window":"catalogs-info-window___1JmM2","date":"date___2cifp"};